"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file @preserve */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  chooseShade: 'Choose shade',
  favorites: 'Favorites',
  goToProduct: 'Go to product',
  quickBuy: 'Quick buy'
};
const translationsNamespace = exports.translationsNamespace = 'shade-picker';
//# sourceMappingURL=defaultTranslations.js.map